import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
//import counter from './counter';
import user from "./user";
import localization from "./localization";
import featureFlags from "./featureFlags";
import config from "./config";

export default combineReducers({
  router: routerReducer,
  user,
  localization,
  featureFlags,
  config
  //counter
});



// WEBPACK FOOTER //
// ./src/modules/index.js